<template>
  <div>
    <v-select
      :value="value.layout || 'center'"
      :items="[
        { text: 'Centered (No Image)', value: 'center' },
        { text: 'Image Left, Form Right', value: 'left' },
        { text: 'Form Left, Image Right', value: 'right' }
      ]"
      label="Form Layout Style"
      outlined
      dense
      @input="update('layout', $event)"
    />

    <ImageUploader
      v-if="value.layout === 'left' || value.layout === 'right'"
      :value="value.image"
      label="Side Image"
      class="mb-3"
      @input="update('image', $event)"
    />

    <v-text-field
      :value="value.title"
      label="Form Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <v-text-field
      :value="value.subtitle"
      label="Subtitle"
      outlined
      dense
      @input="update('subtitle', $event)"
    />
    <div class="mb-3 px-2 text-caption grey--text text--darken-1 d-flex align-center">
      <v-icon small color="blue" class="mr-1">mdi-information-outline</v-icon>
      Name, Email, and Phone fields are mandatory and automatically included.
    </div>
    <div class="d-flex align-start mb-2">
      <v-autocomplete
        :value="customFields"
        :items="availableFields"
        label="Additional Custom Fields"
        outlined
        dense
        multiple
        small-chips
        deletable-chips
        hide-details
        class="flex-grow-1"
        @input="updateCustomFields"
      >
        <template v-slot:no-data>
          <div class="px-4 py-2 text-caption grey--text text--darken-1">
            No fields found. 
            <a href="/#/fields" target="_blank" style="text-decoration: none; font-weight: 600;">Manage Fields</a>
          </div>
        </template>
      </v-autocomplete>
      
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="primary"
            class="ml-2 mt-1"
            href="/#/fields"
            target="_blank"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus-box</v-icon>
          </v-btn>
        </template>
        <span>Add or Manage Custom Fields</span>
      </v-tooltip>
    </div>
    <div class="px-2 mb-4 text-caption grey--text" style="font-size: 11px !important;">
      Select additional fields defined in your GoDial account
    </div>

    <v-text-field
      :value="value.buttonText"
      label="Submit Button Text"
      outlined
      dense
      @input="update('buttonText', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  computed: {
    ...mapGetters(["fieldList", "user"]),
    availableFields() {
      if (!this.fieldList) return [];
      var blocked = ['name', 'email', 'phone'];
      return this.fieldList
        .map(f => f.name)
        .filter(n => !blocked.includes(n.toLowerCase()));
    },
    customFields() {
      var arr = Array.isArray(this.value.fields) ? this.value.fields : [];
      return arr.filter(f => !['name', 'email', 'phone'].includes(f.toLowerCase()));
    }
  },
  created() {
    if ((!this.fieldList || this.fieldList.length === 0) && this.user && this.user.companyId) {
      this.$store.dispatch('getFields', { companyId: this.user.companyId });
    }
  },
  methods: {
    updateCustomFields(val) {
      this.update('fields', ['name', 'email', 'phone', ...val]);
    },
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
  },
};
</script>
